import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useI18n } from 'vue-i18n';
import ListLoadingPlaceholder from '@/components/ListLoadingPlaceholder.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfoliosLoadingPlaceholder',
  setup(__props) {

const { t } = useI18n();
const captions = [
  {
    caption: t('portfolio.apr.caption'),
    tooltip: t('portfolio.apr.tooltip'),
  },
  {
    caption: t('portfolio.liquidity.caption'),
  },
  {
    caption: t('portfolio.lpTokenPrice30.caption'),
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ListLoadingPlaceholder, {
      captions: captions,
      count: "4"
    })
  ]))
}
}

})